export type RegisterKind =
  | 'baptisms'
  | 'confirmations'
  | 'marriages'
  | 'funerals'
  | 'transfers';

export interface MarriageWitness {
  memberId: string | null;
  name: string | null;
}

export interface RegisterRow {
  id: string;
  memberId?: string | null;
  spouseOneMemberId?: string | null;
  spouseTwoMemberId?: string | null;
  personName?: string;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  spouseOneName?: string;
  spouseTwoName?: string;
  baptismDate?: string;
  confirmationDate?: string;
  marriageDate?: string;
  serviceDate?: string;
  transferDate?: string;
  dateOfDeath?: string | null;
  burialDate?: string | null;
  place?: string | null;
  ministerName?: string | null;
  officiatingMinisters?: string[];
  officiantName?: string | null;
  spouseOneWitnesses?: MarriageWitness[];
  spouseTwoWitnesses?: MarriageWitness[];
  baptismNumber?: string | null;
  confirmationNumber?: string | null;
  certificateNumber?: string | null;
  letterReference?: string | null;
  otherChurchName?: string | null;
  direction?: 'in' | 'out';
  baptismType?: 'infant' | 'adult' | 'unknown';
  marriageType?: 'church' | 'civil' | 'customary' | 'other';
  motherMemberId?: string | null;
  motherName?: string | null;
  fatherMemberId?: string | null;
  fatherName?: string | null;
  photoKey?: string | null;
  photoUrl?: string | null;
  certificatePhotoKey?: string | null;
  certificatePhotoUrl?: string | null;
  notes?: string | null;
}

export const dateFor = (kind: RegisterKind, row: RegisterRow): string | null => {
  switch (kind) {
    case 'baptisms':
      return row.baptismDate ?? null;
    case 'confirmations':
      return row.confirmationDate ?? null;
    case 'marriages':
      return row.marriageDate ?? null;
    case 'funerals':
      return row.dateOfDeath ?? null;
    case 'transfers':
      return row.transferDate ?? null;
  }
};

export const funeralDateFor = (row: RegisterRow): string | null => row.serviceDate ?? null;

export const personFor = (kind: RegisterKind, row: RegisterRow): string => {
  if (kind === 'marriages') {
    return [row.spouseOneName, row.spouseTwoName].filter(Boolean).join(' & ') || '—';
  }
  return row.personName || '—';
};

export const marriageMinisterNames = (row: RegisterRow): string[] => {
  const listed = (row.officiatingMinisters ?? []).map((name) => name.trim()).filter(Boolean);
  if (listed.length > 0) return listed;
  const legacy = row.ministerName?.trim();
  return legacy ? [legacy] : [];
};

export const certificateFor = (kind: RegisterKind, row: RegisterRow): string | null => {
  switch (kind) {
    case 'baptisms':
      return row.baptismNumber ?? null;
    case 'confirmations':
      return row.confirmationNumber ?? null;
    case 'marriages':
      return row.certificateNumber ?? null;
    case 'transfers':
      return row.letterReference ?? null;
    case 'funerals':
      return null;
  }
};
